import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { createAccessPointAccessMethod } from 'store/actions/accessPoints/access-methods/create/createAccessPointAccessMethod';
import { fetchAccessPoint } from 'store/actions/accessPoints/fetchAccessPoints';
import { fetchProduct } from 'store/actions/products/fetchProducts';
import AccessMethodCreate from './AccessMethodCreate';
import Actions from 'components/ui/general/Actions';
import Breadcrumbs, { generateBreadcrumbsFromPath } from 'components/layout/Layout/Breadcrumbs';
import Card from 'components/ui/card/Card';
import CardText from 'components/ui/card/CardText';
import fetchResourceById from 'components/hoc/fetchResourceById';
import Header from 'components/ui/general/Header';
import ListButton from 'components/button/ListButton';
import Title from 'components/ui/general/Title';
import translate from 'components/hoc/translate';

class AccessMethodCreateContainer extends React.Component {
    componentDidMount() {
        if (this.props.productId) {
            const { fetchAccessPointProduct, productId } = this.props;

            fetchAccessPointProduct(productId);
        }
    }

    handleSubmit = (values) => {
        const {
            createAccessMethod,
            history,
            id,
            productId,
        } = this.props;

        return new Promise((resolve) => {
            createAccessMethod({
                onError: resolve,
                onSuccess: () => {
                    resolve(history.push(`/products/${ productId }/access-points/${ id }/show`));
                },
                values,
            });
        });
    }

    render() {
        const {
            data,
            id,
            parentResource,
            product,
            productId,
            resource,
            translate,
        } = this.props;

        const breadcrumbsPayload = {
            [resource]: translate('resources.access_points.title'),
            [id]: data,
        };

        if (parentResource && productId) {
            breadcrumbsPayload[productId] = product;
            breadcrumbsPayload[parentResource] = translate(`resources.${ parentResource }.title`);
        }

        const breadcrumbs = generateBreadcrumbsFromPath(breadcrumbsPayload, this.props);

        return (
            <div>
                <Breadcrumbs breadcrumbs={ breadcrumbs } />

                <Header>
                    <Title
                        title={ translate('resources.access_methods.create.title') }
                    />

                    <Actions>
                        <ListButton
                            url={ `/${ resource }/${ id }/show` }
                        />
                    </Actions>
                </Header>

                <Card>
                    <CardText>
                        <AccessMethodCreate
                            { ...this.props }
                            form='access_methods_create'
                            handleSubmitForm={ this.handleSubmit }
                        />
                    </CardText>
                </Card>

            </div>
        );
    }
}

AccessMethodCreateContainer.propTypes = {
    createAccessMethod: PropTypes.func,
    data: PropTypes.object,
    fetchAccessPointProduct: PropTypes.func,
    history: PropTypes.shape({
        push: PropTypes.func,
    }).isRequired,
    id: PropTypes.number.isRequired,
    parentResource: PropTypes.string,
    product: PropTypes.object,
    productId: PropTypes.string,
    resource: PropTypes.string,
    translate: PropTypes.func.isRequired,
};

const mapStateToProps = (state, props) => {

    const additionalProps = {};

    if (props.productId) {
        const { productId } = props;

        additionalProps.product = state.products.data[productId] || null;
    }

    return {
        ...additionalProps,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        createAccessMethod: (payload) => {
            dispatch(createAccessPointAccessMethod(payload));
        },
        fetchAccessPointProduct: (id) => {
            dispatch(fetchProduct({
                id: id,
            }));
        },
    };
};

const enhance = compose(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
    translate,
    fetchResourceById({
        action: fetchAccessPoint,
        resource: 'access-points',
    })
);

export default enhance(AccessMethodCreateContainer);



// WEBPACK FOOTER //
// ./src/pages/accessPoints/access-methods/create/AccessMethodCreateContainer.js